<div class="openapp" *ngIf="showMobileAppOption && !incidentMobile && !isNearMissPage">
  <div class="d-flex justify-content-start align-items-center">
    <a class="OA-close" (click)="closeAppNotif()"><i class="fas fa-times"></i></a>
    <div class="appicon">
      <img src="assets/images/logo_new.svg" height="50px">
    </div>
    <div style="width: 168px;">
      <div class="OA-head">Use the App for best
        experience!</div>
      <div class="OA-stars"><i class="fas fa-star"></i> <i class="fas fa-star"></i> <i class="fas fa-star"></i> <i
          class="fas fa-star"></i> <i class="fas fa-star"></i> Android & iOS</div>

    </div>
    <div>
      <a href="https://goaudits.com/review/" (click)="openApp()" class="OA-btn">Open App</a>
    </div>
  </div>
</div>

<app-header *ngIf="showHeaderAndSidebar"></app-header>
<app-sidebar *ngIf="showHeaderAndSidebar"></app-sidebar>
<!-- <app-header></app-header>
<app-sidebar></app-sidebar> -->
<app-right-sidebar></app-right-sidebar>
<router-outlet></router-outlet>
<!-- <mat-progress-bar mode="indeterminate" *ngIf="loaderService.visibility | async"></mat-progress-bar> -->
<!-- <div class="progress-bar" *ngIf="loaderService.visibility | async">
    <div class="spinner-pos">
        <mat-spinner mode="indeterminate" [diameter]="50" class="spinner"></mat-spinner>
    </div>
</div> -->
<!-- <div class="spinner-parent-div" *ngIf="loaderService.visibility | async">
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div> -->
<!-- <div class='loader' >
    <div class="text-center pb-15"><img src="./assets/images/logo_new.svg" height="80px"></div>
    <div class='loader--dot'></div>
    <div class='loader--dot'></div>
    <div class='loader--dot'></div>
    <div class='loader--dot'></div>
    <div class='loader--dot'></div>
    <div class='loader--dot'></div>
    <div class='loader--text'></div>
  </div> -->
<app-my-loader></app-my-loader>
<app-footer *ngIf="!showHeaderAndSidebar"></app-footer>
